import ApplicationData, { ApplicationDataFull } from '../../types/ApplicationData'
import ConfigurationData, { ConfigurationDataFull } from '../../types/Configuration'
import { ConstelaConfigurationModule } from '../../types/ConstelaConfiguration'
import ModuleData, { AvailableModuleData, isPlacable, isSupportingColumnData } from '../../types/ModuleData'
import { isDefined } from '../utils/typeGuards'
import { makeValidConfig } from './ConstelaConfiguration'

const fillModules = (modules: AvailableModuleData[], defaultModules: ModuleData[]): ModuleData[] => {
  return modules
    .map((module) => {
      const original = defaultModules.find((x) => x.id === module.id)
      return (
        original && {
          ...original,
          ...module
        }
      )
    })
    .filter(isDefined)
}

const convertConstelaConfigurationModule = (
  data: ConfigurationData,
  configProperties: Record<string, string>,
  availableModules: ModuleData[]
) => (input: string | ConstelaConfigurationModule): ConstelaConfigurationModule => {
  const id = typeof input === 'string' ? input : input.id
  const propertiesIn = typeof input === 'string' ? {} : input.properties ?? {}
  const module = availableModules.find((x) => x.id === id)
  if (module && 'propertyMenu' in module && module.propertyMenu?.length) {
    const properties = makeValidConfig(data, propertiesIn, {
      ...configProperties,
      module: module.id
    })
    return { id, properties }
  } else {
    return { id }
  }
}

const fillApplicationData = (data: ConfigurationData) => (application: ApplicationData): ApplicationDataFull => {
  const availableModules = fillModules(application.availableModules, data.modules).concat(
    data.modules.filter(isSupportingColumnData)
  )
  const defaultConfigurationProperties = makeValidConfig(data, application.defaultConfiguration.properties ?? {}, {
    module: 'global'
  })
  const convertModule = convertConstelaConfigurationModule(data, defaultConfigurationProperties, availableModules)
  const result: ApplicationDataFull = {
    ...application,
    availableModules,
    defaultConfiguration: {
      ...application.defaultConfiguration,
      type: undefined,
      properties: defaultConfigurationProperties,
      lightingHead: convertModule(application.defaultConfiguration.lightingHead),
      modules: application.defaultConfiguration.modules.map(convertModule),
      services: application.defaultConfiguration.services.map(convertModule),
      supportingColumn: convertModule(application.defaultConfiguration.supportingColumn)
    }
  }
  if (data.properties[0].id === 'switchingType') {
    throw new Error('wtf! ' + application.id)
  }
  return result
}

export const fillConfigurationData = (data: ConfigurationData): ConfigurationDataFull => {
  return {
    ...data,
    applications: data.applications.map(fillApplicationData(data)),
    system: {
      maxHeight: 7000,
      width:
        Math.max(
          ...data.modules
            .filter(isPlacable)
            .map((x) => (x.center ? Math.max(x.center, x.width - x.center) : x.width / 2))
        ) * 2
    }
  }
}
